import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _get from "lodash/get";
import React, { useContext } from 'react';
import { Box } from '@rebass/grid';
import { ThemeContext } from 'styled-components';
import layoutTheme from '../../styles/layoutTheme';

var Col = function Col(_ref) {
  var xxs = _ref.xxs,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl,
      flex = _ref.flex,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["xxs", "xs", "sm", "md", "lg", "xl", "flex", "children"]);

  var theme = useContext(ThemeContext);
  var xxsValue;
  var xsValue;
  var smValue;
  var mdValue;
  var lgValue;
  var xlValue;

  var gutter = _get(theme, 'layout.grid.gutter', layoutTheme.layout.grid.gutter);

  var col = _get(theme, 'layout.grid.columns', layoutTheme.layout.grid.columns);

  if (xxs) {
    xxsValue = xxs / col;
  }

  if (xs) {
    xsValue = xs / col;
  }

  if (sm) {
    smValue = sm / col;
  }

  if (md) {
    mdValue = md / col;
  }

  if (lg) {
    lgValue = lg / col;
  }

  if (xl) {
    xlValue = xl / col;
  }

  return /*#__PURE__*/React.createElement(Box, Object.assign({
    px: gutter,
    width: [xxsValue, xsValue, smValue, mdValue, lgValue, xlValue],
    flex: flex
  }, props), children);
};

Col.defaultProps = {
  xxs: null,
  xs: null,
  sm: null,
  md: null,
  lg: null,
  xl: null,
  flex: undefined,
  children: null
};
export default Col;